import React from "react";
import { Split } from "lucide-react";
import { Modal } from "../Modal";

/**
 * Confirm-and-split modal — moves the selected line items to a new
 * delivery note. Parent owns selection state and the API call.
 */
export function JobSplitModal({
  job, selected, splitNote, setSplitNote,
  busy, onCancel, onConfirm,
}) {
  const remaining = (job.items?.length || 0) - selected.size;
  const nextDn = job.family?.length
    ? `${job.family[0]?.delivery_note_number}-${String(job.family.length + 1).padStart(2, "0")}`
    : `${job.delivery_note_number}-02`;
  return (
    <Modal open onClose={onCancel} icon={Split}
      title={`Split ${job.delivery_note_number}`}
      subtitle={`${selected.size} item${selected.size === 1 ? "" : "s"} will move to a new delivery note · ${remaining} will remain.`}
      footer={
        <>
          <button className="btn ghost" onClick={onCancel} disabled={busy} data-testid="job-split-cancel">Cancel</button>
          <button className="btn gold" onClick={onConfirm} disabled={busy || !selected.size}
            data-testid="job-split-confirm">
            <Split size={14} /> Create new DN &amp; move items
          </button>
        </>
      }
    >
      <div className="card pad" style={{ background: "var(--card-2)", marginBottom: 12, fontSize: 13 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>What happens next</div>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.65 }}>
          <li><b>{remaining}</b> item{remaining === 1 ? "" : "s"} stay on <b>{job.delivery_note_number}</b></li>
          <li><b>{selected.size}</b> item{selected.size === 1 ? "" : "s"} move to a brand new DN (auto-numbered <b>{nextDn}</b>)</li>
          <li>Customer, contact, end-user, notes and quote reference are copied to the new DN</li>
          <li>Already-issued certificates keep their original DN reference (immutable)</li>
          <li>Quoting, invoicing and dispatch from this point onward follow each DN independently</li>
        </ul>
      </div>
      <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "var(--text-2)", marginBottom: 4 }}>
        Reason for split (optional)
      </label>
      <textarea className="input" rows={2} value={splitNote}
        onChange={(e) => setSplitNote(e.target.value)}
        data-testid="job-split-note"
        placeholder="e.g. Caliper repair will take 3 weeks — dispatching the other items separately." />

      <div style={{ marginTop: 12, fontSize: 12, color: "var(--text-3)" }}>
        Items being moved: <b>{selected.size}</b>
        {selected.size > 0 && (
          <ul style={{ margin: "6px 0 0", paddingLeft: 18, color: "var(--text-2)" }}>
            {[...selected].map((sid) => {
              const it = job.items?.find((x) => x.id === sid);
              return it ? <li key={sid}>{it.description || "Item"}{it.serial_number ? ` · SN ${it.serial_number}` : ""}</li> : null;
            })}
          </ul>
        )}
      </div>
    </Modal>
  );
}
